export const CAROUSEL_VERSION_1 = '1';
